import { useMutation } from '@tanstack/react-query'

import { cancelPaymentRequest } from '@src/api'
import { DefaultApiCancelPaymentRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useCancelPaymentRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiCancelPaymentRequestRequest) =>
      cancelPaymentRequest(axiosInstance, params),
  })
}
